import 'normalize.css';
import '../src/style.css';

import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

import mainPage from './components/mainPage/mainPage';

mainPage();
